import React from 'react';
import IrrigationChart from '../../../../../../components/Highcharts/IrrigationChart/IrrigationChart';
import StackedSoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/StackedSoilMoistureChart/StackedSoilMoistureChart';
import SoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/SoilMoistureChart/SoilMoistureChart';
import RootsChart from '../../../../../../components/Highcharts/RootsChart/RootsChart';
import useStyles from '../../../../../../components/Highcharts/styles';
import useResponsiveChartHeight from '../../../../../../hooks/useResponsiveChartHeight';

function SoilDashboard({
  sectorId,
  farmId,
}: {
  sectorId: string,
  farmId: string,
}) {
  const classes = useStyles();
  const {
    minionChartHeight, smallChartHeight, mediumChartHeight, largeChartHeight,
  } = useResponsiveChartHeight();

  return (
    <div className={classes.dashboardContainer}>
      <IrrigationChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Kc y mm"
      />
      <StackedSoilMoistureChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={mediumChartHeight}
        title="Humedad de suelo"
        yAxisTitle=" "
      />
      <RootsChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={minionChartHeight}
        yAxisTitle=""
        title="Profundidad riego y raíces"
      />
      <SoilMoistureChart
        chartView="dashboard"
        hideYValues={false}
        hideXValues={false}
        hideLegend={true}
        sectorId={sectorId}
        farmId={farmId}
        height={largeChartHeight}
        title="Sumatoria humedad de suelo"
        yAxisTitle=" "
      />
    </div>
  );
}

export default SoilDashboard;
